import { FC, JSX } from "react";
import { Flex, Container, Section, Button } from "@radix-ui/themes";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import SignOut from "@/features/auth/components/SignOut/SignOut";
import ProfileCoverPhoto from "@/features/profile/components/single/Profile.Coverphoto";
import ProfileAbout from "@/features/profile/components/single/Profile.About";
import ProfileRating from "@/features/profile/components/single/Profile.Rating";
import ProfileBiography from "@/features/profile/components/single/Profile.Biography";
import { siteRoutes } from "@/routes/siteRoutes";
import { useNavigate } from "react-router-dom";

const ProfilePage: FC = (): JSX.Element => {
  const user = useCurrentUserProfile((s) => s.user);
  const navigate = useNavigate();

  return (
    <>
      {/* Cover Photo */}
      <ProfileCoverPhoto coverURL={user.coverURL} />

      <Container px={{ initial: "4", lg: "0" }}>
        {/* Details */}
        <ProfileAbout {...user} />
      </Container>
      <Container px={{ initial: "4", lg: "0" }}>
        <Section size="1">
          <Flex direction="column" gap="5">
            {/* About */}
            <ProfileBiography {...user} />

            {/* Star Ratings */}
            <ProfileRating />
          </Flex>
        </Section>

        <Section size="1">
          <Flex gap="3">
            <Button onClick={() => navigate(siteRoutes.profile.edit.path)}>
              {siteRoutes.profile.edit.label}
            </Button>
            <SignOut />
          </Flex>
        </Section>
      </Container>
    </>
  );
};

export default ProfilePage;
